import { createRouter, createWebHistory } from 'vue-router';
import Login from './components/Login.vue';
import ResetPassword from './components/ResetPassword.vue';
import Profile from './components/Profile.vue';
import GDQAdmin from './components/GDQAdmin.vue';
import ImportConsultants from './components/ImportConsultants.vue';
import SupportIssue from './components/SupportIssue';
import Consultants from './components/Consultants';
import InvoiceReport from './components/InvoiceReport';
import Companies from './components/Companies';
import Partners from './components/Partners';
import Mailsettings from './components/MailSettings';
import GDQSettings from './components/GDQSettings';
import GDQShortSettings from './components/GDQShortSettings';
import OSCSettings from './components/OSCSettings';
import AggregatedReportSettings from './components/AggregatedReportSettings';
import Maintenance from './components/Maintenance.vue';
import MaintenanceTree from './components/Maintenance/MaintenanceTree';
import LoginText from './components/LoginText';
import Planner from './components/Planner';
import GDQUtils from './components/GDQUtils';
import ReportList from './components/ReportList';
import LearningMaterials from './components/LearningMaterials';
import CourseBookings from './components/CourseBookings';
import Events from './components/Events';
import Event from './components/Event';
import Bookings from './components/Bookings';
import BulkMailDesign from './components/BulkMailDesign';
import ExamCorrection from './components/ExamCorrection.vue';
import ExamCorrectionDetailVue from './components/ExamCorrectionDetail.vue';
import BulkMailing from './components/BulkMailing.vue';
import NormvaluesExport from './components/NormvaluesExport.vue';
import store from './store';

//-------
// Routes
//-------
const routes = [
  //------------------
  // Login and profile
  //------------------
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      breadCrumbs: [{
        to: 'login', text: 'Login'
      }]
    }
  },
  {
    name: 'resetpassword',
    path: '/resetpassword/:t',
    component: ResetPassword,
    meta: {
      breadCrumbs: [{
        to: 'resetpassword', text: 'Reset Password'
      }]
    }
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/profile', text: 'Profile' }
      ]
    }
  },
  //------------------
  // My GDQ Management
  //------------------
  {
    name: 'gdqadministration',
    path: '/',
    component: GDQAdmin,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' }
      ]
    }
  },
  //-------------------
  // Import Consultants
  //-------------------
  {
    name: 'importconsultants',
    path: '/importconsultants',
    component: ImportConsultants,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/importconsultants', text: 'Import Consultants' }
      ]
    }
  },
  //------------------------------
  // Support issues - planner view
  //------------------------------
  {
    name: 'planner',
    path: '/planner',
    component: Planner,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/planner', text: 'Planner' }
      ],
      navbar: true,
    }
  },
  //---------------------------
  // Support issues - list view
  //---------------------------
  {
    name: 'supportissues',
    path: '/supportissues',
    component: Maintenance,
    props: { tablename: 'g_supportissues', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/supportissues', text: 'Support Issues List' }
      ],
      navbar: true,
    }
  },
  //--------------
  // Support Issue
  //--------------
  {
    name: 'supportissue',
    path: '/supportissue/:id?',
    component: SupportIssue,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/supportissue', text: 'Support Issue' }
      ]
    }
  },
  // MAIN MENU
  {
    name: 'systemmessages',
    path: '/systemmessages',
    component: Maintenance,
    props: { tablename: 'g_systemmessages', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/systemmessages', text: 'System messages' }
      ],
      navbar: true,
    }
  },
  {
    name: 'logintext',
    path: '/logintext',
    component: LoginText,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/logintext', text: 'Login screen text' }
      ],
      navbar: true,
    }
  },
  {
    name: 'consultants',
    path: '/consultants',
    component: Consultants,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/consultants', text: 'Consultants' }
      ]
    }
  },
  {
    name: 'consultantgroups',
    path: '/consultantgroups',
    component: Maintenance,
    props: { tablename: 'g_consultantgroups', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/consultantgroups', text: 'Consultant Groups' }
      ],
      navbar: true,
    }
  },
  {
    name: 'invoicereport',
    path: '/invoicereport',
    component: InvoiceReport,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/invoicereport', text: 'Invoices' }
      ]
    }
  },
  {
    name: 'companies',
    path: '/companies',
    component: Companies,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/companies', text: 'Companies' }
      ]
    }
  },
  {
    name: 'partners',
    path: '/partners',
    component: Partners,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/partners', text: 'Partners' }
      ]
    }
  },

  {
    name: 'mailsettings',
    path: '/mailsettings',
    component: Mailsettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/mailsettings', text: 'Mail Settings' }
      ]
    }
  },
  {
    name: 'gdqsettings',
    path: '/gdqsettings',
    component: GDQSettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/gdqsettings', text: 'GDQ Settings' }
      ]
    }
  },
  {
    name: 'gdqshortsettings',
    path: '/gdqshortsettings',
    component: GDQShortSettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/gdqshortsettings', text: 'GDQ Short Settings' }
      ]
    }
  },
  {
    name: 'oscsettings',
    path: '/oscsettings',
    component: OSCSettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/oscsettings', text: 'OSC Settings' }
      ]
    }
  },
  {
    name: 'aggregatedreportsettings',
    path: '/aggregatedreportsettings',
    component: AggregatedReportSettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/aggregatedreportsettings', text: 'Aggregated Reports Settings' }
      ]
    }
  },
  {
    name: 'countries',
    path: '/countries',
    component: Maintenance,
    props: { tablename: 'g_countries', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/countries', text: 'Countries' }
      ],
      navbar: true,
    }
  },
  {
    name: 'labels',
    path: '/labels',
    component: Maintenance,
    props: { tablename: 'g_labels', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/labels', text: 'Labels' }
      ],
      navbar: true,
    }
  },
  {
    name: 'languages',
    path: '/languages',
    component: Maintenance,
    props: { tablename: 'g_languages', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/languages', text: 'Languages' }
      ],
      navbar: true,
    }
  },
  {
    name: 'faq',
    path: '/faq',
    component: Maintenance,
    props: { tablename: 'g_faq', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/faq', text: 'FAQ' }
      ],
      navbar: true,
    }
  },
  {
    name: 'faqcategories',
    path: '/faqcategories',
    component: Maintenance,
    props: { tablename: 'g_faqcategories', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/faqcategories', text: 'FAQ Categories' }
      ],
      navbar: true,
    }
  },
  {
    name: 'utilities',
    path: '/utilities',
    component: GDQUtils,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/utilities', text: 'Utilities' }
      ],
      navbar: true,
    }
  },
  {
    name: 'screens',
    path: '/screens',
    component: Maintenance,
    props: { tablename: 'g_systemscreens', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/screens', text: 'Screens' }
      ],
      navbar: true,
    }
  },
  {
    name: 'screenelements',
    path: '/screenelements',
    component: Maintenance,
    props: { tablename: 'g_systemscreenelements', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/screenelements', text: 'Screen elements' }
      ],
      navbar: true,
    }
  },
  {
    name: 'consentresearch',
    path: '/consentresearch',
    component: ReportList,
    props: { viewname: 'gdq_consentresearch', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/consentresearch', text: 'Consent to Research' }
      ],
      navbar: true,
    }
  },
  {
    name: 'consent',
    path: '/consent',
    component: ReportList,
    props: { viewname: 'gdq_consent', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/consent', text: 'Consent to Personal Information' }
      ],
      navbar: true,
    }
  },
  // Normvalues export
  {
    name: 'normvaluesexport',
    path: '/normvaluesexport',
    component: NormvaluesExport,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/normvaluesexport', text: 'Export for normvalues' }
      ],
      navbar: true,
    }
  },
  // e-Learning routes
  {
    key: 'courses',
    name: 'courses',
    path: '/courses',
    component: MaintenanceTree,
    props: { tablename: 'g_elearning_courses', mainfield: '', mainvalue: -1, standalone: false, noedit: false, detailmodal: true },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/courses', text: 'e-Learning courses' }
      ],
      navbar: true,
    }
  },
  // e-Learning materials
  {
    name: 'elearningmaterials',
    path: '/elearningmaterials',
    component: LearningMaterials,
    props: { tablename: 'g_elearning_materials', mainfield: '', mainvalue: -1, standalone: false, noedit: false, detailmodal: true },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/elearningmaterials', text: 'e-Learning materials' }
      ],
      navbar: true,
    } 
  },
  // e-Learning exams
  {
    name: 'elearningexams',
    path: '/elearningexams',
    component: Maintenance,
    props: { tablename: 'g_elearning_exams', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/elearningexams', text: 'e-Learning Exams' }
      ],
      navbar: true,
    }
  },
  {
    key: 'elearningexamstree',
    name: 'elearningexamstree',
    path: '/elearningexamstree',
    component: MaintenanceTree,
    props: { tablename: 'g_elearning_exams', mainfield: '', mainvalue: -1, standalone: false, noedit: false, detailmodal: true },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/exlearningexamstree', text: 'e-Learning Exams Tree' }
      ],
      navbar: true,
    }
  }, 
  // e-Learning questions
  {
    name: 'elearningquestions',
    path: '/elearningquestions',
    component: Maintenance,
    props: { tablename: 'g_elearning_questions', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/elearningquestions', text: 'e-Learning Questions' }
      ],
      navbar: true,
    }
  },
  {
    name: 'elearningreferences',
    path: '/elearningreferences',
    component: Maintenance,
    props: { tablename: 'g_elearning_references', mainfield: '', mainvalue: -1, standalone: false, noedit: false },
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/elearningreferences', text: 'e-Learning References' }
      ],
      navbar: true,
    }
  },

  // E-learning course bookings
  {
    name: 'coursebookings',
    path: '/coursebookings',
    component: CourseBookings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/coursebookings', text: 'Course Bookings' }
      ],
      navbar: true,
    }
  },
  // Event booking
  {
    name: 'eventmails',
    path: '/eventmails',
    component: BulkMailDesign,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/eventmails', text: 'Event mails' }
      ],
      navbar: true,
    }
  },
  {
    name: 'events',
    path: '/events',
    component: Events,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/events', text: 'Events' }
      ],
      navbar: true,
    }
  },
  {
    name: 'event',
    path: '/event/:id',
    component: Event,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/events', text: 'Events' },
        { to: '/event/:id', text: 'Event' }
      ],
      navbar: true,
    }
  },
  {
    name: 'bookings',
    path: '/bookings',
    component: Bookings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/bookings', text: 'Event Bookings' }
      ],
      navbar: true,
    }
  },
  // Exam correction
  {
    name: 'examcorrection',
    path: '/examcorrection',
    component: ExamCorrection,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/examcorrection', text: 'Exam Correction' }
      ],
      navbar: true,
    }
  },
  {
    name: 'examcorrectiondetailsel',
    path: '/examcorrectiondetail/:course_id/:exam_id/:consultant_id',
    component: ExamCorrectionDetailVue,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/examcorrection', text: 'Exam Correction' },
        { to: '/examcorrectiondetail', text: 'Exam Correction Answers' }
      ],
      navbar: true,
    }
  },
  {
    name: 'examcorrectiondetail',
    path: '/examcorrectiondetail',
    component: ExamCorrectionDetailVue,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/examcorrection', text: 'Exam Correction' },
      ],
      navbar: true,
    }
  },
  {
    name: 'bulkmailing',
    path: '/bulkmailing',
    component: BulkMailing,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'GDQ Administration' },
        { to: '/bulkmailing', text: 'Bulk Mailing' }
      ],
      navbar: true,
    }
  },  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      store.dispatch('setrouteafterlogin', '');
      next();
      return;
    }
    const redirectTarget = to.path === '/login' ? '' : to.fullPath;
    store.dispatch('setrouteafterlogin', redirectTarget);
    next('/login');
  } else {
    next();
  }
});

export default router;
